import { Tooltip } from "antd/lib";
import styled from "styled-components";

//APP

//STYLES
const Circle = styled.div`
    width: 15px;
    height: 15px;
    border-radius: 50%;
`;

//PROPS
interface Props {
    valor: number;
}

export const SmallCircleEscala: React.FC<Props> = ({ valor }) => {

    function background() {
        if (valor===0) {
            return '#01FF00'
        }
        if (valor > 0 && valor <= 1.5) {
            return '#FCFF02'
        }
        if (valor > 1.5 && valor <= 2.5) {
            return '#FCB700'
        }
        if (valor > 2.5 && valor <= 3.5) {
            return '#FB0303'
        }
        if (valor > 3.5) {
            return '#b80000'
        }
        else {
            'gray'
        }
    }

    return (
        <Tooltip title={`${valor.toFixed(2)}`} zIndex={9999}>
            <samp data-valor={valor}>
                <Circle style={{background: background()}} />
            </samp>
        </Tooltip>
    )
}
